<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PORTL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="portalId"
              :selected="searchBox.portalId"
              :option-list="selectPortalList"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="searchBox.systemUseSearchConditionCode"
              codeId="COD_SYS_USE_SEARCH_COND"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :required="true"
              :label="$t('MSG_TXT_LOOKUP_PERIOD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t("MSG_TXT_APPLICATION") }}</h4>
            <div class="btn_wrap">
              <sui-button
                v-permission:download="this.$options.name"
                type="button"
                class="comm_btn_gridTop comm_ico_excel"
                @click="onDownloadExcelApplication"
              >
                {{ $t("MSG_BTN_EXCEL_DOWN") }}
              </sui-button>
            </div>
          </div>
          <sui-grid
            ref="gridApplicationStats"
            :columns="gridColumns0"
            :dataset="'dsApplicationStats'"
            :hideHeader="true"
            :multiselect="false"
            :initialPagesize="10"
          />
        </div>
        <div class="btnbox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t("MSG_TXT_MENU") }}</h4>
            <div class="btn_wrap">
              <sui-button
                v-permission:download="this.$options.name"
                type="button"
                class="comm_btn_gridTop comm_ico_excel"
                @click="onDownloadExcelMenu"
              >
                {{ $t("MSG_BTN_EXCEL_DOWN") }}
              </sui-button>
            </div>
          </div>
          <sui-grid
            ref="gridMenuStats"
            :columns="gridColumns1"
            :dataset="'dsMenuStats'"
            :hideHeader="true"
            :multiselect="false"
            :initialPagesize="10"
            :sortable="false"
          />
        </div>
      </div>
    </sui-page-contents>
    <sui-popup
      v-model="isShownPopup"
      :title="$t('MSG_TIT_SYS_USE_STATS_DTL')"
    >
      <p01
        :pageId="this.$options.name"
        :searchBox="paramSearchBox"
        :selectedId="selectedId"
        :applicationName="applicationName"
        :popupType="popupType"
        @onClose="popOpenOrClose"
      />
    </sui-popup>
  </sui-page>
</template>

<script>
import p01 from './components/PGE_CMP_00014_P01';

export default {
  name: 'PGE_CMP_00014', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  data() {
    return {
      // searchBox rangeDatePicker
      rangeDate: {
        from: utils.now('YYYY-MM-01'),
        to: utils.now('YYYY-MM-DD'),
      },
      // searchBox portalOptionList
      selectPortalList: [],

      // Search Box
      searchBox: {
        systemUseSearchConditionCode: { key: '', label: '' },
        startDTM: '',
        endDTM: '',
        portalId: { key: '', label: '' },
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_APPLICATION_NM'),
        datafield: 'applicationName',
      }, {
        text: this.$t('MSG_TXT_TOT_CLICK_NUM'),
        datafield: 'totalConnectionNumber',
        width: 100,
      }, {
        text: `${this.$t('MSG_TXT_USR_NUM')} / ${this.$t('MSG_TXT_DEPT_NUM')}`,
        datafield: 'connectionNumber',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement,
            {
              type: 'link',
              handler: this.onGridStateClickedApplication,
            }, this.dsApplicationStats, this.$refs.gridApplicationStats);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 150,
      }],

      localdata1: [],
      gridColumns1: [
        {
          text: this.$t('MSG_TXT_MENU_NM'),
          datafield: 'treeMenuName',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellTreeItem(row, column, value, htmlElement, {
            }, this.dsMenuStats, this.$refs.gridMenuStats);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        { text: this.$t('MSG_TXT_TOT_CLICK_NUM'), datafield: 'totalConnectionNumber', width: 100 },
        {
          text: `${this.$t('MSG_TXT_USR_NUM')} / ${this.$t('MSG_TXT_DEPT_NUM')}`,
          datafield: 'connectionNumber',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement,
              {
                type: 'link',
                handler: this.onGridStateClickedMenu,
              }, this.dsMenuStats, this.$refs.gridMenuStats);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 150,
        },
      ],

      // excel
      excelMenuGridColumns: [
        {
          text: this.$t('MSG_TXT_MENU_NM'),
          datafield: 'menuName',
        },
        { text: this.$t('MSG_TXT_TOT_CLICK_NUM'), datafield: 'totalConnectionNumber', width: 100 },
        {
          text: `${this.$t('MSG_TXT_USR_NUM')} / ${this.$t('MSG_TXT_DEPT_NUM')}`,
          datafield: 'connectionNumber',
          width: 120,
        },
      ],

      // popup
      isShownPopup: false,
      selectedId: '',
      applicationName: '',
      popupType: 'M',
      paramSearchBox: {},
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsApplicationStats',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'portalId',
      type: 'string',
      map: 'portalId',
    }, {
      name: 'applicationId',
      type: 'string',
      map: 'applicationId',
    }, {
      name: 'applicationName',
      type: 'string',
      map: 'applicationName',
    }, {
      name: 'totalConnectionNumber',
      type: 'string',
      map: 'totalConnectionNumber',
    }, {
      name: 'connectionNumber',
      type: 'string',
      map: 'connectionNumber',
    }],
  }, {
    id: 'dsMenuStats',
    data: 'localdata1',
    datafields: [{
      name: 'treeMenuName',
      type: 'Object',
      map: 'treeMenuName',
    }, {
      name: 'menuLogObjectId',
      type: 'string',
      map: 'menuLogObjectId',
    }, {
      name: 'menuName',
      type: 'string',
      map: 'menuName',
    }, {
      name: 'totalConnectionNumber',
      type: 'string',
      map: 'totalConnectionNumber',
    }, {
      name: 'connectionNumber',
      type: 'string',
      map: 'connectionNumber',
    }, {
      name: 'parentsMenuUid',
      type: 'string',
      map: 'parentsMenuUid',
    }, {
      name: 'menuLevel',
      type: 'string',
      map: 'menuLevel',
    }, {
      name: 'arrayalOrder',
      type: 'string',
      map: 'arrayalOrder',
    }],
  }],
  mounted() {
    this.dsApplicationStats.$on(this.dsApplicationStats.EVENTS.SELECTION_CHANGED,
      this.onSelectionChangedByDsApplicationStats);

    // portal list
    this.selectPortalList = [];
    http.request(this.$options.name, 'DTS_CMP_00004')
      .then(res => {
        utils.forEach(res.data, obj => {
          this.selectPortalList.push({
            key: obj.portalId,
            label: obj.portalName,
          });
        });
      })
      .catch(error => {
        console.log(error);
      });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    this.dsApplicationStats.$off(this.dsApplicationStats.EVENTS.SELECTION_CHANGED,
      this.onSelectionChangedByDsApplicationStats);
  },
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      this.dsApplicationStats.clearSelection();

      this.searchApplicationStatsList();
      this.paramSearchBox = utils.cloneDeep(this.searchBox);
      this.dsMenuStats.setRawData([]);
    },
    onSelectionChangedByDsApplicationStats() {
      const objData = this.dsApplicationStats.getSelectedRawData();
      if (objData.length === -1 || objData.length === 0) {
        return false;
      }
      this.searchMenuStatsList(objData[0].applicationId, objData[0].portalId);
      return true;
    },
    onGridStateClickedApplication(btn, selectedRawData) {
      // searchBox, popupType, selectedId
      this.popupType = 'A';
      this.selectedId = `${selectedRawData.applicationId}|${selectedRawData.portalId}`;
      this.applicationName = selectedRawData.applicationName;

      this.popOpenOrClose();
    },
    onGridStateClickedMenu(btn, selectedRawData) {
      // searchBox, popupType, selectedId
      this.popupType = 'M';
      this.selectedId = selectedRawData.menuLogObjectId;

      this.applicationName = selectedRawData.menuName;

      this.popOpenOrClose();
    },
    onDownloadExcelApplication() {
      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns0;
      const objGridDataset = this.dsApplicationStats;

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `menuStatus_app_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName);
    },
    onDownloadExcelMenu() {
      const sPageId = this.$options.name;
      const objGridColumns = this.excelMenuGridColumns;
      const objGridDataset = this.dsMenuStats;

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `menuStatus_menu_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName);
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    popOpenOrClose() {
      this.isShownPopup = !this.isShownPopup;
    },
    setDatePickerToSearchBox() {
      if (this.rangeDate.from !== null && this.rangeDate.from !== '') {
        this.searchBox.startDTM = utils.dateformatToServer(this.rangeDate.from);
      }
      if (this.rangeDate.to !== null && this.rangeDate.to !== '') {
        this.searchBox.endDTM = `${utils.dateformatToServer(this.rangeDate.to).substring(0, 8)}235959`;
      }
    },
    resetSearchBox() {
      this.searchBox.systemUseSearchConditionCode.key = 'D';
      this.$refs.portalId.select(0);
      this.rangeDate = {
        from: utils.now('YYYY-MM-01'),
        to: utils.now('YYYY-MM-DD'),
      };
    },
    searchApplicationStatsList() {
      // datePicker 설정 값
      this.setDatePickerToSearchBox();

      // if (this.onClickValidate()) return false;
      if (this.validationCheck()) return false;

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.$options.name, 'DTS_CMP_00038', {
        query: queryParams,
      }).then(res => {
        this.dsApplicationStats.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });

      return true;
    },
    searchMenuStatsList(sApplicationId, sPortalId) {
      // 유효성 체크
      if (utils.isEmpty(sApplicationId)) {
        // utils.messageBox('warning', 'Application 을 선택 해주세요.');
        return false;
      }

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      // portalId
      utils.assign(queryParams, { portalId: utils.trim(sPortalId) });

      http.request(this.$options.name, 'DTS_CMP_00039', {
        path: {
          'application-id': utils.trim(sApplicationId),
        },
        query: queryParams,
      }).then(res => {
        const flatData = utils.convertTreedataToFlatdata(res.data, 'menuLogObjectId', 'parentsMenuUid');
        // 트리 구조 세팅
        utils.forEach(flatData, item => {
          const objItem = item;
          objItem.treeMenuName = { text: item.menuName, depth: item.menuLevel };
        });

        this.dsMenuStats.setRawData(flatData);
      }).catch(error => {
        console.log(error);
      });

      return true;
    },
    validationCheck() {
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      if (utils.isEmpty(this.$refs.datePicker.value.to) || utils.isEmpty(this.$refs.datePicker.value.from)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_LOOKUP_PERIOD')));
        return true;
      }
      return false;
    },
    // validationCheck() {
    //   if (utils.isEmpty(this.searchBox.startDTM, '') || utils.isEmpty(this.searchBox.endDTM)) {
    //     utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_LOOKUP_PERIOD')));
    //     return true;
    //   }
    //   return false;
    // },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    // onClickValidate() {
    //   // if (this.onClickValidate()) return false;
    //   if (!this.$refs.datePicker.isValid()) {
    //     utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
    //     return true;
    //   }
    //   return false;
    // },
  },
};
</script>
<style scoped>
</style>
